export default {"src":"/_next/static/media/discount_bg_image.016308f2.svg","height":39,"width":55,"blurWidth":0,"blurHeight":0};